import { Controller } from "@hotwired/stimulus"

// Slider hero Mon Jour — navigation entre actions prioritaires
export default class extends Controller {
  static targets = ["track", "slide", "dot", "counter", "prev", "next"]

  connect() {
    this.index = 0
    this.update()
  }

  next(event) {
    event?.preventDefault()
    if (this.index >= this.slideTargets.length - 1) return
    this.index += 1
    this.update()
  }

  prev(event) {
    event?.preventDefault()
    if (this.index <= 0) return
    this.index -= 1
    this.update()
  }

  goto(event) {
    event?.preventDefault()
    const idx = parseInt(event.currentTarget.dataset.index, 10)
    if (!isNaN(idx)) {
      this.index = idx
      this.update()
    }
  }

  update() {
    if (this.hasTrackTarget) {
      this.trackTarget.style.transform = `translateX(${-this.index * 100}%)`
    }
    this.slideTargets.forEach((s, i) => {
      if (i === this.index) {
        s.classList.add("is-active")
      } else {
        s.classList.remove("is-active")
      }
    })
    this.dotTargets.forEach((d, i) => {
      d.dataset.active = (i === this.index) ? "true" : "false"
    })
    if (this.hasCounterTarget) {
      this.counterTarget.textContent = `${this.index + 1} / ${this.slideTargets.length}`
    }
    if (this.hasPrevTarget) this.prevTarget.disabled = this.index === 0
    if (this.hasNextTarget) this.nextTarget.disabled = this.index >= this.slideTargets.length - 1
  }
}
